import merge from 'lodash/merge';
import {twMerge} from '../../../common/twMerge';
import {theme} from '../../../theme';
import {ToggleProps} from './ToggleProps.interface';

export function Toggle({
  isActive,
  isDisabled,
  activeBackgroundColor = theme.colors['static-point-yellow'],
  inActiveBackgroundColor = theme.colors['theme-solid-100'],
  sliderColor = theme.colors['static-mono-white'],
  sliderSizePx = 20,
  className,
  style,
  onClickToggle,
  ...props
}: ToggleProps) {
  return (
    <div
      className={twMerge(
        'relative flex cursor-pointer flex-row items-center rounded-full',
        isDisabled && 'cursor-not-allowed opacity-30',
        className
      )}
      style={merge(
        {
          justifyContent: isActive ? 'flex-end' : 'flex-start',
        },
        style
      )}
      onClick={isDisabled ? undefined : onClickToggle}
      {...props}
    >
      <div
        className="absolute inset-0 rounded-full"
        style={
          isActive
            ? {backgroundColor: activeBackgroundColor}
            : {
                backgroundColor: inActiveBackgroundColor,
                opacity: 0.15,
              }
        }
      />
      <div
        className={twMerge(
          'relative rounded-full',
          !isActive && 'border border-solid border-theme-transparent-10'
        )}
        style={{
          width: sliderSizePx,
          height: sliderSizePx,
          backgroundColor: sliderColor,
        }}
      />
    </div>
  );
}
